const customHeaderTemplate = (data) => {
  return (
    <div>
      <div className="d-flex">
        <div>
          <i className="icon-window-filled pointer F-size14" onClick={data?.onHide}></i>
          {/* <i className="icon-window-filled pointer F-size14 icon-minimize"></i> */}
        </div>
      </div>
    </div>
  );
};

const renderFooter = () => {
  return <div></div>;
};

const dialogHelpers = {
  customHeaderTemplate,
  renderFooter,
};

export default dialogHelpers;
